import React from 'react';

const AboutIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm0 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10z"/><path d="M10.5 5h3v3h-3zM10.5 10h3v9h-3z"/></svg>    )
};

export default AboutIcon;